module.exports = __webpack_public_path__ + "4b82adde155ecd5f131146d49dd86f3d.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-leo-01.jpg
 ** module id = 354
 ** module chunks = 0
 **/